import type { ReadCircuitKey } from "./types";

// The run writes this in front of a group it bucketed by symbol because it read
// no identifier beside the devices. "grp·Sirene" is not a printed key.
const FALLBACK_KEY_PREFIX = "grp·";

export const readCircuitKey: ReadCircuitKey = ({ circuit }) => {
  const key = circuit.circuitKey?.trim();
  if (!key || key.startsWith(FALLBACK_KEY_PREFIX)) return null;
  return key;
};
